'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgWaitCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M8 2a5.99 5.99 0 00-6 6c0 3.321 2.679 6 6 6s6-2.679 6-6-2.679-6-6-6zm0 1.286A4.68 4.68 0 0112.714 8 4.68 4.68 0 018 12.714 4.68 4.68 0 013.286 8 4.68 4.68 0 018 3.286zm1.718 1.85v1.718h-.002l.002.003L8.573 8l1.145 1.146-.002.003h.002v1.715H6.282V9.15h.002l-.002-.003L7.427 8 6.282 6.857l.002-.003h-.002V5.136h3.436zm-.987.807H7.297v.627l.717.717.717-.717v-.627z", fill: "currentColor" }))));
}

module.exports = SvgWaitCircle;
//# sourceMappingURL=WaitCircle.js.map
